import { service } from '@ember/service'
import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import type UiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type SessionService from 'district-ui-client/services/session'
import type { NormalizedInterval } from 'date-fns'
import type { DistrictScope } from 'district-ui-client/utils/student-events/stats-scope'

export default class ReportingReSummaryTableRoute extends Route {
  @service studentEvents!: StudentEventsService

  @service session!: SessionService

  async model() {
    const { uiScope, period, scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<UiScopeRoute>

    const product: LegacyProductRe = 're'
    const stats = await this.makeStatsRequest(product, period)

    return {
      product,
      uiScope,
      period,
      scopedData,
      ...stats,
    }
  }

  makeStatsRequest = (product: LegacyProductRe, period: NormalizedInterval) => {
    const districtScope: DistrictScope = {
      ids: [this.session.currentDistrict.id],
      scope: 'district',
    }

    return RSVP.hash({
      simpleSummary: this.studentEvents.simpleSummary(product, districtScope, period),
    })
  }
}
